import Background from "@components/background";
import { Contain } from "@components/layout";
import { getWordpressUrl } from "@lib/wordpressVars";
import { Avatar, Col, Row, Space } from "antd";
import bg from "./bg.png";

const Header = ({ partnerLogoUrl, partnerHelpInfo }) => {

    return (
        <Background
            className={`pp-header`}
            src={getWordpressUrl(bg)}
            size={`contain`}
            parallax={false}
            repeat={true}
        >
            <Contain>
                <Row
                    justify={`space-between`}
                    align={`middle`}
                >
                    <Col className={`left logo`}>
                        <Space direction={`horizontal`}>
                            <img alt="logo" src={partnerLogoUrl} />
                        </Space>
                    </Col>
                    <Col className={`right`}>
                        <Space direction={`horizontal`}>
                            <Avatar size={75} src={
                                <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="37" cy="37" r="37" fill="white" />
                                    <path d="M53.157 22.8142H43.4969L42.0107 28.5098H53.1105C54.6431 28.5098 55.8506 29.8021 55.8506 31.3337V45.5487C55.8506 47.1281 54.5967 48.3725 53.1105 48.3725H40.7568H36.6234L33.9297 59.668L39.2242 54.0681H53.157C57.7083 54.0681 61.4238 50.2392 61.4238 45.5487V31.3337C61.4238 26.6432 57.7083 22.8142 53.157 22.8142Z" fill="black" />
                                    <path d="M18.0258 45.7924V31.425C18.0258 29.8286 19.3283 28.5709 20.872 28.5709H38.528L40.0717 22.8142H20.872C16.1444 22.8142 12.2852 26.6842 12.2852 31.425V45.7924C12.2852 50.5332 16.1444 54.4032 20.872 54.4032H31.6296L33.1733 48.6465H20.872C19.28 48.6465 18.0258 47.3888 18.0258 45.7924Z" fill="black" />
                                    <path d="M30.9489 36.6794C32.6288 36.6794 33.282 37.0103 33.7487 37.4831L34.1686 37.9558L36.2685 36.0176L35.8485 35.5449C35.0086 34.6468 33.702 34.2213 31.6022 34.2213C27.9625 34.2213 25.2094 36.0176 24.4627 38.9012C23.6695 41.832 25.4427 43.581 29.129 43.581C31.2755 43.581 32.9087 43.1083 34.2153 42.1156L34.8219 41.6429L33.7487 39.7048L33.0487 40.2248C32.4888 40.6502 31.6488 41.1229 29.7357 41.1229C26.5626 41.1229 27.0292 39.4212 27.1692 38.8539C27.5892 37.4358 28.8491 36.6794 30.9489 36.6794Z" fill="black" />
                                    <path d="M38.8105 43.581L39.5365 40.7536H42.7127C46.4334 40.7536 47.5224 38.6574 47.84 37.39C48.3845 35.2938 47.2048 34.2213 44.3462 34.2213H38.5836L36.2695 43.581H38.8105ZM40.5347 36.805H43.5748C45.3898 36.805 45.299 37.1462 45.2083 37.4875C45.1175 37.78 45.0268 38.2187 43.2118 38.2187H40.1717L40.5347 36.805Z" fill="black" />
                                </svg>

                            } />
                            <Space size={[0, 0]} direction={`vertical`}>
                                {partnerHelpInfo?.displayName
                                    && <h3 className="name">{partnerHelpInfo?.displayName}</h3>}
                                {partnerHelpInfo?.userEmail
                                    && <a className="email" href="mailTo:">{partnerHelpInfo?.userEmail}</a>}
                                {partnerHelpInfo?.userPhone
                                    && <a className="phone" href="tel:">{partnerHelpInfo?.userPhone}</a>}
                            </Space>
                        </Space>
                    </Col>
                </Row>
            </Contain>
        </Background>
    );
};

export default Header;
